<div style="position: relative; height: 100%; width: 100%; background-color: black" class="video-players">
	<div class="videoDivClass">
		<video class="videoClass" style="width: 99.9%; height: 100%" id="preRollvideo" autoplay #videoName [src]="videoURL">
			<source type="video/mp4" />
			Your browser does not support HTML5 video.
		</video>
	</div>
	<div class="showIconsControls" style="position: absolute; top: 0px; width: 100%; height: 100%">
		<span class="playVideo playbuttom" *ngIf="isPaused" (click)="toggleVideoPlay()">
			<img id="playBtn" class="volumeClass" style="width: 18%" [src]="defaultVideoBtns.play" />
		</span>
		<span class="playVideo playbuttom" *ngIf="!isPaused" (click)="toggleVideoPlay()">
			<img id="pauseBtn" class="volumeClass" style="width: 18%" [src]="defaultVideoBtns.pause" />
		</span>
	</div>
	<div class="volumeControls" style="position: absolute; bottom: 5px; width: 9%; height: 15%; right: 7px">
		<span id="volumeBtn" class="volumeControlIcon" (click)="toggleVideoMute()" *ngIf="!isMuted">
			<img class="volumeClass" [src]="defaultVideoBtns.mute" />
		</span>
		<span id="muteBtn" class="volumeControlIcon" (click)="toggleVideoMute()" *ngIf="isMuted">
			<img class="volumeClass" [src]="defaultVideoBtns.unmute" />
		</span>
	</div>
</div>
